import { cn } from "@/lib/utils";
import { createPath } from "@/service/routing/routing";
import { Badge } from "@/components/ui/badge";
import Link from "next/link";
import { TruncatedTitle } from "./truncated-title";

interface StepsListProps {
  steps: RoadmapStepPreviewVM[];
  activeStep?: RoadmapStepPreviewVM;
  specialization: RoadmapVM;
  isExpanded: boolean;
  isLastPath: boolean;
  tokenQuery?: string;
}

export const StepsList = ({
  steps,
  activeStep,
  specialization,
  isExpanded,
  isLastPath,
  tokenQuery,
}: StepsListProps) => {
  return (
    <div className="z-0 flex flex-col">
      {steps.map((step) => {
        const isCompleted = step.progress?.isCompleted ?? false;
        const isStepActive = step.id === activeStep?.id;
        const isLastStep = step.id === steps[steps.length - 1].id;

        return (
          <Link
            key={step.id}
            className={cn(
              "relative z-10 flex h-[34px] w-full items-center gap-4 px-5 py-2 text-left transition-all",
              isStepActive ? "bg-[#eeefff]" : "hover:bg-[#f6f6ff]",
            )}
            href={
              createPath("roadmap.step.show", {
                specialization: specialization.slug,
                path: step.path.slug,
                step: step.slug,
              }) + (tokenQuery ?? "")
            }
          >
            {/* Vertical Line for this path and its steps */}
            {isExpanded && (
              <div
                className={cn(
                  "absolute top-0 left-[31px] z-0 h-[calc(100%)] w-[1px] bg-zinc-300",
                  isLastStep && isLastPath ? `h-[50%]` : "h-[100%]",
                )}
              />
            )}
            {/* Step Icon Container (Aligned exactly with Path icon) */}
            <div className={cn("z-1 flex w-6 shrink-0 justify-center py-1")}>
              <div
                className={cn(
                  "h-2 w-2 rounded-full",
                  isStepActive
                    ? "bg-remedium-blue"
                    : isCompleted
                    ? "bg-teal-500"
                    : "bg-zinc-300",
                )}
              />
            </div>

            {/* Step Content */}
            <div className="flex flex-1 items-center gap-2 overflow-hidden">
              <TruncatedTitle
                title={step.title}
                className={cn(
                  "text-[12px]",
                  isStepActive ? "font-semibold text-black" : "text-zinc-600",
                )}
              />
              {isStepActive && (
                <Badge className={"bg-remedium-blue rounded-full text-white"}>
                  tu jesteś
                </Badge>
              )}
            </div>
          </Link>
        );
      })}
    </div>
  );
};
